import axios from "axios";

export const API = axios.create({
  baseURL: "https://ridojiadmin.skyapi.store/",
  // baseURL: "http://localhost:3678/",
});
